module.exports = __webpack_public_path__ + "static/img/09.29f19c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/09.png
// module id = yBeZ
// module chunks = 1